import { useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { useIntl } from 'react-intl';
//Styles
import './imageUpload.scss';

const ImageUpload = (props) => {
    const { addFile, files, setFiles } = props;
    const { messages } = useIntl()
    
    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': []
        },
        onDrop: acceptedFiles => {
            setFiles(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));
        }
    });

    const thumbs = files.map(file => (
        <div className='thumb' key={file.name}>
            <div className='thumb-inner'>
                <img
                    src={file.preview}
                    className='thumb-img'
                    onLoad={() => { URL.revokeObjectURL(file.preview) }}
                    loading="lazy"
                />
            </div>
        </div>
    ));

    useEffect(() => {
        if (files) addFile(files)
        return () => files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);

    return (
        <section
            className="container"
            style={{
                width: "100%",
                height: "150px",
                objectFit: "cover",
                objectPosition: "center",
                border: " 1px dashed",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: 'pointer',
            }}
        >
            {!files.length ? (
                <div {...getRootProps({ className: 'dropzone' })}>
                    <input {...getInputProps()} />
                    <p>{messages['upload_image_drap_drop']}</p>
                </div>
            ) : (
                <aside className='image-upload-container'>
                    {thumbs}
                </aside>
            )
            }
        </section>
    )
}

export default ImageUpload;